/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegenerateInterimReportDto } from '../../models/regenerate-interim-report-dto';
import { RegenerationTextResultDto } from '../../models/regeneration-text-result-dto';

export interface DocumentAiV2ControllerRegenerateInterimReport$Params {
      body: RegenerateInterimReportDto
}

export function documentAiV2ControllerRegenerateInterimReport(http: HttpClient, rootUrl: string, params: DocumentAiV2ControllerRegenerateInterimReport$Params, context?: HttpContext): Observable<StrictHttpResponse<RegenerationTextResultDto>> {
  const rb = new RequestBuilder(rootUrl, documentAiV2ControllerRegenerateInterimReport.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RegenerationTextResultDto>;
    })
  );
}

documentAiV2ControllerRegenerateInterimReport.PATH = '/api/document-ai-v2/interim-report-ai/regenerate';
